




























































import Modal from "../core/Modals/Modal.vue";
import { DocumentNonReconnu } from "../models/DocumentNonReconnu";
import { DocumentNonReconnuApi } from "../api/DocumentNonReconnuApi";

export default {
    name: "DocumentNonReconnuReclasserModal",
    components: { Modal },
    props: {
        document: DocumentNonReconnu,
        showModal: Boolean,
    },
    data() {
        return {
            selectedType: null,
            saving: false,
            DocumentNonReconnuApi: new DocumentNonReconnuApi(),
            types: [
                {
                    id: DocumentNonReconnu.TYPE_DOCUMENT["Facture"],
                    name: DocumentNonReconnu.TYPE_LABELS[
                        DocumentNonReconnu.TYPE_DOCUMENT["Facture"]
                    ],
                },
                {
                    id: DocumentNonReconnu.TYPE_DOCUMENT["BulletinDeSalaire"],
                    name: DocumentNonReconnu.TYPE_LABELS[
                        DocumentNonReconnu.TYPE_DOCUMENT["BulletinDeSalaire"]
                    ],
                },
                {
                    id: DocumentNonReconnu.TYPE_DOCUMENT["AvisDeVirement"],
                    name: DocumentNonReconnu.TYPE_LABELS[
                        DocumentNonReconnu.TYPE_DOCUMENT["AvisDeVirement"]
                    ],
                },
                {
                    id: DocumentNonReconnu.TYPE_DOCUMENT["AvisDePrelevement"],
                    name: DocumentNonReconnu.TYPE_LABELS[
                        DocumentNonReconnu.TYPE_DOCUMENT["AvisDePrelevement"]
                    ],
                },
            ],
        };
    },
    methods: {
        closeModal(): void {
            this.selectedType = null;
            this.$emit("close-modal");
        },
        save(): void {
            let self = this;

            if (self.saving) {
                return;
            }
            if (!self.selectedType) {
                swal("Veuillez sélectionner un type de document", "", "error");
                return;
            }

            self.saving = true;
            self.DocumentNonReconnuApi.reclasser(
                self.document.id,
                self.selectedType
            )
                .then(function (response) {
                    self.saving = false;
                    self.$emit("reclassed", response.metadata);
                    self.closeModal();
                })
                .catch(function (error) {
                    self.saving = false;
                    let message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        "Le reclassement a échoué";
                    self.$emit("reclass-failed");
                    self.closeModal();
                    swal(message, "", "error");
                });
        },
    },
};
